import React from "react";
import { createContext, useContext } from "react";
import type {
	LocaleId,
	SupportedLocaleIds,
} from "../containers/route/localeByLocaleId";

interface SiteContext {
	backendApiUrl: string;
	bookingManagementApiUrl: string;
	defaultLocaleId: LocaleId;
	supportedLocaleIds: SupportedLocaleIds;
}

const Context = createContext<SiteContext | null>(null);

interface SiteContextProviderProps {
	value: SiteContext;
}

export const SiteContextProvider: React.FC<SiteContextProviderProps> = ({
	children,
	value,
}) => {
	return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useSite = () => {
	const context = useContext(Context);

	if (!context) {
		throw new Error("useSite must be used within a SiteContextProvider");
	}

	return context;
};
